import React from 'react';

import ImageWithLabel from '@shared/components/layouts/ImageWithLabel';

interface ILabelComponent {
    src: string;
    label: string;
}

export const LabelComponent = ({ src, label }: ILabelComponent) => (
    <ImageWithLabel
        label={label}
        alt={label}
        styles={{
            wrapper: {
                margin: '0px 0px 0px 10px',
                cursor: 'pointer',
            },
            label: {
                overflow: 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap',
                width: '170px',
            },
            image: {
                'border-radius': '50%',
                height: '31px',
                width: '31px',
            },
        }}
        src={src}
        icon={null}
    />
);
